import { useState } from "react";
import { CalendarOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../store/hooks";
import { useReservationsLocked } from "../../../../../hooks/useEdgeMode";
import type { SecondaryAction } from "../OptionsPopover";
import { SeatReservationModal } from "./SeatReservationModal";

// Правото на бутона (org seed) — BE: `SEAT_PERMISSION` в reservations/router.py.
const SEAT_PERMISSION = "seat_reservations";

/**
 * „Настани" в „Опции" на лентата под масите: действието и модалът. Без
 * клавиш и без брояч. Без правото — нищо (null). В локален режим бутонът
 * стои заключен само срещу каса, която не умее резервации.
 */
export const useSeatReservationAction = ({ onSeated }: { onSeated: (billId: number) => void }) => {
  const { t } = useTranslation();
  const permissions = useAppSelector((state) => state.auth.permissions);
  const canSeat = permissions.some((permission) => permission.name === SEAT_PERMISSION);
  const locked = useReservationsLocked();
  const [open, setOpen] = useState(false);

  const action: SecondaryAction | null = canSeat
    ? {
        key: "seatReservation",
        label: t("seatReservation.action"),
        icon: <CalendarOutlined />,
        onClick: () => setOpen(true),
        lockedTooltip: locked ? t("edge.unavailableOffline") : undefined,
      }
    : null;

  const modal = canSeat ? (
    <SeatReservationModal open={open} onClose={() => setOpen(false)} onSeated={onSeated} />
  ) : null;

  return { action, modal, open };
};
